import { format } from "date-fns";

export const Modulecolumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "module", headerName: "Module", flex: 1 },
  { field: "company", headerName: "Company", flex: 1 },
];

export const RightsColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "title", headerName: "Title", flex: 1 },
  { field: "icon", headerName: "Icon", flex: 1 },
  { field: "action", headerName: "Action", flex: 1 },
  { field: "module", headerName: "Module", flex: 1 },
];
export const RoleGroupColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "roleGroup", headerName: "Role Group", flex: 1 },
];

export const CasesColumns = [
  { field: "id", headerName: "ID", flex: 0.2, headerClassName: "header-cell" },
  {
    field: "clientType",
    headerName: "Client Type",
    flex: 2,
    headerClassName: "header-cell",
  },
  {
    field: "caseNumber",
    headerName: "Case Number",
    flex: 1,
    headerClassName: "header-cell",
  },
  {
    field: "title",
    headerName: "Title",
    flex: 1,
    headerClassName: "header-cell",
  },
  {
    field: "description",
    headerName: "Description",
    flex: 2,
    headerClassName: "header-cell",
  },
  {
    field: "categoryName",
    headerName: "Category Name",
    flex: 2,
    headerClassName: "header-cell",
  },
  {
    field: "subcategoryName",
    headerName: "Subcategory Name",
    flex: 2,
    headerClassName: "header-cell",
  },
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    headerClassName: "header-cell",
  },
  {
    field: "caseStatus",
    headerName: "Case Status",
    flex: 1,
    headerClassName: "header-cell",
  },
];

export const TeamAssignmentsColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "username", headerName: "Username", flex: 1 },
  { field: "firstName", headerName: "First Name", flex: 1 },
  { field: "lastName", headerName: "Last Name", flex: 1 },
  { field: "email", headerName: "Email", flex: 1 },
  { field: "role", headerName: "Role", flex: 1 },
];

export const FactColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "factDescription", headerName: "Fact Description", flex: 2 },
];
export const CaseTasksColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  {
    field: "dueDate",
    headerName: "Due Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formattedDate = format(new Date(params.value), "MM/dd/yyyy");
      return formattedDate;
    },
  },
  // { field: "dueDate", headerName: "Due Date", flex: 1, type: "date" },
  { field: "description", headerName: "Description", flex: 2 },
  { field: "done", headerName: "Completed", flex: 0.5, type: "boolean" },
  // { field: "statusFlag", headerName: "Status Flag", flex: 1 },
];
export const CaseEventColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "description", headerName: "Event Description", flex: 2 },
];

export const JudgeAssignmentColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "name", headerName: "Name", flex: 1 },
];

export const DocumentUploadColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "caseTitle", headerName: "Case Title", flex: 2 },
  { field: "title", headerName: "Title", flex: 1 },
  { field: "caseNumber", headerName: "Case Number", flex: 1 },
  { field: "fileName", headerName: "File Name", flex: 1 },
  // { field: "firstName", headerName: "First Name", flex: 1 },
  // { field: "lastName", headerName: "Last Name", flex: 1 },
  // { field: "roleName", headerName: "Role Name", flex: 1 },
  // { field: "authorId", headerName: "Author ID", flex: 1 },
  // { field: "caseId", headerName: "Case ID", flex: 1 },
  {
    field: "createdDate",
    headerName: "Created Date",
    flex: 1,
    type: "date",
    renderCell: (params) => {
      const formattedDate = format(new Date(params.value), "MM/dd/yyyy");
      return formattedDate;
    },
  },
  // { field: "lastModifiedDate", headerName: "Last Modified Date", flex: 1 },
  { field: "filePath", headerName: "File Path", flex: 1 },
  // { field: "companyId", headerName: "Company ID", flex: 1 },
  // { field: "deleted", headerName: "Deleted", flex: 1 },
  // { field: "deletedDate", headerName: "Deleted Date", flex: 1 },
  // { field: "company", headerName: "Company", flex: 1 },
];

export const CourtAssignmentsColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "caseNumber", headerName: "Case Number", flex: 1 },
  { field: "caseTitle", headerName: "Case Title", flex: 1 },
  { field: "caseDescription", headerName: "Case Description", flex: 1 },
  { field: "court", headerName: "Court", flex: 1 },
  { field: "subCounty", headerName: "Sub-County", flex: 1 },
  { field: "county", headerName: "County", flex: 1 },
];

export const CorporateClientsColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "companyName", headerName: "Company Name", flex: 1 },
  { field: "contactNumber", headerName: "Contact Number", flex: 1 },
  { field: "email", headerName: "Email", flex: 2 },
  { field: "address", headerName: "Address", flex: 1 },
  { field: "industrySector", headerName: "Industry Sector", flex: 1 },
];

export const IndividualClientsColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "customerName", headerName: "Name", flex: 1 },
  { field: "phoneNumber", headerName: "Phone Number", flex: 2 },
  { field: "email", headerName: "Email", flex: 2 },
  { field: "creditApproved", headerName: "Credit Approved", flex: 1 },
  { field: "customerBalance", headerName: "Customer Balance", flex: 2 },
];


export const ChargeLinesColumns = [
  { field: "id", headerName: " id", flex: 1 },
  { field: "description", headerName: "Description", flex: 1 },
  { field: "price", headerName: "Price", flex: 1 },
  //{ field: "processWorkFlow", headerName: "Process Work Flow", flex: 1 },
  //{ field: "email", headerName: "Email", flex: 1 },
];

export const AccountTypesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "accountType", headerName: "Account Type", flex: 1 },
];
export const MajorClassificationColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "majorClassification", headerName: "MajorClassification", flex: 1 },
  // { field: "company", headerName: "Company", flex: 1 },
];
export const MinorClassificationColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "minorClassification", headerName: "Minor Classification", flex: 1 },
  // { field: "company", headerName: "Company", flex: 1 },
];
export const ReportTypesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "majorClassification", headerName: "Major Classification", flex: 1 },
  { field: "minorClassification", headerName: "Minor Classification", flex: 1 },
  { field: "reportName", headerName: "Report Name", flex: 1 },
];
export const ReportBrowserColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "module", headerName: "Module", flex: 1 },
  { field: "company", headerName: "Company", flex: 1 },
];
export const PurchaseOrderItemsColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "productCode", headerName: "Product Code", flex: 1 },
  { field: "aliasProductName", headerName: "Alias", flex: 1 },
  { field: "productName", headerName: "Product Name", flex: 1 },
  { field: "vendorName", headerName: "Vendor Name", flex: 1 },
  { field: "vendorComments", headerName: "Vendor Comments", flex: 1 },
  { field: "cartons", headerName: "Cartons", flex: 1 },
  { field: "quantityPerCarton", headerName: "Quantity/Carton", flex: 1 },
  { field: "amount", headerName: "Amount", flex: 1 },
  { field: "quantity", headerName: "Quantity", flex: 1 },
  { field: "stockDueDate", headerName: "Stock Due Date", flex: 1 },
  { field: "reversed", headerName: "Is Reversed", flex: 1 },
];

export const SalesOrderPayments = [
  { field: "methodName", headerName: "Method Name", flex: 1 },
  { field: "amount", headerName: "Amount", flex: 1 },
  { field: "createdDate", headerName: "Created Date", flex: 1 },
  { field: "insertedBy", headerName: "Inserted By", flex: 1 },
  { field: "customerName", headerName: "Customer Name", flex: 1 },
  { field: "phone", headerName: "Phone", flex: 1 },
];
export const PurchaseOrderPayments = [
  { field: "pvId", headerName: "Payment Voucher Id", flex: 0.5 },
  { field: "paymentMethodName", headerName: "Method Name", flex: 1 },
  { field: "amountPaid", headerName: "Amount", flex: 1 },
  { field: "createdDate", headerName: "Created Date", flex: 1 },
  { field: "paymentDate", headerName: "Payment Date", flex: 1 },
  // { field: "pvStatus", headerName: "Payment Status", flex: 1 },
];

export const SalesOrderItemsColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "saleOrder", headerName: "Sale Order", flex: 1 },
  { field: "customerName", headerName: "Customer Name", flex: 1 },
  { field: "productName", headerName: "Product Name", flex: 1 },
  { field: "productCode", headerName: "Product Code", flex: 1 },
  { field: "netAmount", headerName: "Net Amount", flex: 1 },
  { field: "unitofMeasure", headerName: "Unit of Measure", flex: 1 },
  { field: "color", headerName: "Color", flex: 1 },
  { field: "size", headerName: "Size", flex: 1 },
  { field: "quantity", headerName: "Quantity", flex: 1 },
  { field: "saleDate", headerName: "Sale Date", flex: 1 },
  { field: "reversed", headerName: "Is Reversed", flex: 1 },


];
export const PaymentVoucherColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "purchaseOrderId", headerName: "Purchase Order", flex: 1 },
  { field: "vendorId", headerName: "Vendor", flex: 1 },
  { field: "amountPaid", headerName: "Amount Paid", flex: 1 },
  { field: "paymentDate", headerName: "Payment Date", flex: 1 },
  { field: "remarks", headerName: "remarks", flex: 1 },
];
export const FixedExpenseColumns = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "name", headerName: "Expense Name", flex: 1 },
  { field: "amount", headerName: "Amount ($)", flex: 1 },
  { field: "interval", headerName: "Interval", flex: 1 },
  { field: "accountName", headerName: "Account Type", flex: 1 },
  { field: "isActive", headerName: "Status", flex: 1 },
  { field: "actions", headerName: "Actions", flex: 1 },
];
// export const ProductColumns = [
//   { field: "id", headerName: "ID", flex: 1 },
//   { field: "productName", headerName: "Product Name", flex: 1 },
//   { field: "unitPrice", headerName: "Selling Price", flex: 1 },
//   { field: "costPrice", headerName: "Buying Price", flex: 1 },
//   { field: "retailPrice", headerName: "Retail Price", flex: 1 },
//   { field: "wholesalePrice", headerName: "WholeSale Price", flex: 1 },
//   { field: "isActive", headerName: "Status", flex: 1 },
//   // { field: "actions", headerName: "Actions", flex: 1 },
// ];

export const WarehouseDistributionColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "color", headerName: "Color", flex: 1 },
  { field: "cartons", headerName: "Cartons", flex: 1, type: "number" },
  { field: "quantityPerCarton", headerName: "Quantity per Carton", flex: 1, type: "number" },
  { field: "minSize", headerName: "Min Size", flex: 0.8, type: "number" },
  { field: "maxSize", headerName: "Max Size", flex: 0.8, type: "number" },
];